import React, { useState } from "react";
import { Plus, X } from "lucide-react";
import { parseTags } from "../../utils/blogHelpers";
import styles from "./Admin.module.css";

const PillInput = ({
  label,
  values = [],
  onChange,
  placeholder,
  suggestions = [],
  hint,
}) => {
  const [draft, setDraft] = useState("");

  const addValues = (raw) => {
    const incoming = parseTags(raw);
    if (!incoming.length) return;

    const next = [...values];
    incoming.forEach((item) => {
      const exists = next.some((value) => value.toLowerCase() === item.toLowerCase());
      if (!exists) next.push(item);
    });

    onChange(next);
    setDraft("");
  };

  const removeValue = (item) => {
    onChange(values.filter((value) => value !== item));
  };

  return (
    <div className={styles.field}>
      <label>{label}</label>
      <div className={styles.pillBox}>
        {values.map((item) => (
          <span className={styles.editPill} key={item}>
            {item}
            <button type="button" onClick={() => removeValue(item)} aria-label={`Remove ${item}`}>
              <X size={12} />
            </button>
          </span>
        ))}
        <input
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === ",") {
              event.preventDefault();
              addValues(draft);
            }
            if (event.key === "Backspace" && !draft && values.length) {
              removeValue(values[values.length - 1]);
            }
          }}
          placeholder={values.length ? "Add another" : placeholder}
        />
        <button type="button" className={styles.pillAddBtn} onClick={() => addValues(draft)}>
          <Plus size={14} />
          Add
        </button>
      </div>
      {hint ? <p className={styles.hint}>{hint}</p> : null}
      {suggestions.length ? (
        <div className={styles.suggestionRow}>
          {suggestions
            .filter(
              (option) => !values.some((value) => value.toLowerCase() === option.toLowerCase())
            )
            .map((option) => (
              <button
                type="button"
                key={option}
                className={styles.suggestionPill}
                onClick={() => addValues(option)}
              >
                + {option}
              </button>
            ))}
        </div>
      ) : null}
    </div>
  );
};

export default PillInput;
